import {authAPI} from "../api/api";
import {readFromStorage, saveToStorage} from "../api/storageApi";
import { isExpired, decodeToken } from "react-jwt";
import ShowNotification from "../components/common/Notification/ShowNotification"

const SET_USER_DATA = 'SET_USER_DATA';
const LOGOUT_USER = 'LOGOUT_USER';
const IS_LOADING = 'IS_LOADING';
const PAGE_LOADED = 'PAGE_LOADED';

export const setUserData = (id, name, email,isAuth) => {
    return {
        type: SET_USER_DATA,
        payload: {
            id, name, email,isAuth}
    }
}

export const logOutUser =(payload)=>
{
    return{
        type:LOGOUT_USER,
        payload:null
    }
}
export const PageLoadedTrue =(pageLoaded)=>
{
    return{
        type:PAGE_LOADED,
        pageLoaded
    }
}

export const isLoading = (isLoadingStatus) => {
    return {
        type: IS_LOADING,
        isLoadingStatus
    }
}


let  name=  readFromStorage("name") ? readFromStorage("name") : "No username"
let  email=  readFromStorage("email") ? readFromStorage("email") : "No email"
let  id=  readFromStorage("id") ? readFromStorage("id") : "No id"
let  accessToken= readFromStorage("accessToken") ? readFromStorage("accessToken") :  null
let  isAuth= readFromStorage("isAuth") ? readFromStorage("isAuth") : false


let initialState = {
    id:id,
    name:name,
    email:email,
    isAuth: isAuth,
    pageLoaded: false,
    isLoadingStatus: false,
}

let authReducer = (state=initialState,
                   action) => {
    switch (action.type) {
        case SET_USER_DATA:
            return {
                ...action.payload
            }

        case LOGOUT_USER:
            return {
                state:null
            }
        case PAGE_LOADED:
            return {
                ...state,
                pageLoaded:action.pageLoaded
            }

        case IS_LOADING:
            return {
                ...state,
                isLoadingStatus: action.isLoadingStatus
            }
        default :
            return state;
    }
}


export const loginMe = (username, password) => {
    return async (dispatch) => {
        let response = await authAPI.login(username, password );
        if (response !=null){
            saveToStorage('accessToken',response.message)
            dispatch(getUserInfo())
        }
    }
}

export const logOutMe = () => {
    return async (dispatch) => {
        ShowNotification("Logout","You logged out!","danger")
        let response = await authAPI.logout()
        if (response.status===200) {
            dispatch(logOutUser(null))
        }
    }
}
export const getUserInfo= () => {
    return async (dispatch) => {
        let response = await authAPI.user();
        if(response)
        {
            let {id,name,email}=response;
            isAuth=true;
            dispatch(setUserData(id,name,email,isAuth))
            saveToStorage("name",name)
            saveToStorage("email",email)
            saveToStorage("isAuth",isAuth)
            saveToStorage("roles",'ADMIN')
            ShowNotification("Success","You logged in!","success")
        }
    }
}


export default authReducer;
